import { useState, useEffect } from 'react';

export const useSubmenuSide = (buttonRef, subMenuRef, open, hasChildren) => {

    const [side, setSide] = useState('left');

    useEffect(() => {

        if (!open || !buttonRef.current || !subMenuRef.current)
            return;
        const btnRect = buttonRef.current.getBoundingClientRect();
        const menuRect = subMenuRef.current.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const spaceLeft = btnRect.left;
        const spaceRight = viewportWidth - btnRect.right;
        if (spaceLeft >= menuRect.width)
            setSide('left');
        else if (spaceRight >= menuRect.width)
            setSide('right');
        else
            setSide(spaceLeft >= spaceRight ? 'left' : 'right');
        
    }, [open, hasChildren, buttonRef, subMenuRef]);

    return side;
};
